<div class="color active-color" [ngStyle]="{'background-color': color}" (click)="colorPanel.show($event); $event.stopPropagation();">
</div>
<p-popover  #colorPanel appendTo="body" [baseZIndex]="10000">
  <div class="color-chooser">
    @for (color of colors; track color) {
      <div class="color" [ngStyle]="{'background-color': color}" (click)="selectColor(color); colorPanel.hide(); $event.stopPropagation();"></div>
    }
  </div>
</p-popover>
